import gql from 'graphql-tag';

export const DELETE_CLOSE_REASON = gql`
  mutation DeleteBPFCloseReason($id: ID!) {
    bpf {
      result: deleteCloseReason(id: $id) {
        error
        success
        entity {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
